import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteVorlageCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteVorlageCommandService],
  exports: []
})
export class DeleteVorlageCommandServiceModule { }
